<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Organismo Nocivo</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Organismo Nocivo
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpDataType">Tipo de Organismo Nocivo</label>

                                        <ng-select [items]="listTiposOrganismoNocivo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Codigo"
                                                   formControlName="DataType"
                                                   loadingText="Cargando..."
                                                   [loading]="!(listTiposOrganismoNocivo)"
                                                   notFoundText="Organismo Nocivo no encontrada"
                                                   placeholder="-- Seleccione un tipo de Organismo Nocivo --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('DataType')"
                                                   appendTo="body">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DataType','required')">
                                            El tipo de Organismo Nocivo es obligatorio.
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="Code">Código EPPO</label>
                                        <input formControlName="Code" name="Code" class="form-control" id="Code" type="text" value="" maxlength="10">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Code','required')">
                                            El Código es obligatorio.
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="CodeId">Código Numérico</label>
                                        <input formControlName="CodeId" name="CodeId" class="form-control" id="CodeId" value="" maxlength="9" type="number">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodeId','required')">
                                            El Código numérico es obligatorio.
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="FullName">Nombre completo</label>
                                        <input formControlName="FullName" name="FullName" class="form-control" id="FullName" type="text" value="" maxlength="90">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FullName','required')">
                                            El Nombre Completo es obligatorio.
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpPreferred">Favorito</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Preferred" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpRegulatedUe">Regulado por la UE</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="RegulatedUe" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpNoEspecie">No Especie</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="NoEspecie" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
